// extracted by mini-css-extract-plugin
export default {"tagChip":"TagChip_tagChip__fH+XV","tagChipCompact":"TagChip_tagChipCompact__zcVUc"};